import { defineStore } from 'pinia';
import { ref } from 'vue';

export const useFooterStore = defineStore('footer', () => {
  const left = ref('');

  function set (text: string): void {
    left.value = text;
  }

  function clear (): void {
    left.value = '';
  }

  return { left, set, clear };
});
